import React, { Component } from 'react';
import InputRange from 'react-input-range';

class Distance extends Component {

  state = { distance: 25 };

  render() {
    const { filter, styles: { header, body } } = this.props;
    return (
      <div>
        <div style={header || {}} className="filter-head">{filter.name}</div>
        <div className="distance-filter">
          <InputRange
            style={body || {}}
            maxValue={100}
            minValue={25}
            value={this.state.distance}
            formatLabel={value => `${value} miles`}
            onChange={(e) => this.setState({ distance: e })}
            step={5} 
          />
        </div>
      </div>
    );
  }
  
}

export default Distance;
